import { render, staticRenderFns } from "./SupplierNoticeView.vue?vue&type=template&id=74596676&scoped=true&"
import script from "./SupplierNoticeView.vue?vue&type=script&lang=js&"
export * from "./SupplierNoticeView.vue?vue&type=script&lang=js&"
import style0 from "./SupplierNoticeView.vue?vue&type=style&index=0&id=74596676&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74596676",
  null
  
)

export default component.exports